var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vacancy-stages"},_vm._l((_vm.vacancyStages),function(item){return _c('VacancyStage',{key:item.name,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }